<template>
  <div class="notice">
    **Solo se pueden seleccionar recibos de pago a partir de
    {{ minDateReadable }}**
  </div>
</template>

<script>
  import accountStatusPaymentHistoryDate from '@/mixins/accountStatusPaymentHistoryDate';

  export default {
    name: 'PaymentHistoryNotice',

    mixins: [accountStatusPaymentHistoryDate],
  };
</script>
